<router-outlet></router-outlet>
<pos-teclado-virtual *ngIf="false" class="pos-teclado-host"
                      [style.transform]="(posUtility.mostrarTecladoAlpha$ | async)? 'translateX(10%)': ''"
                      [style.z-index]="(posUtility.mostrarTecladoAlpha$ | async)? '5000': ''"
                      [tecladoActivo]="{numerico: false, alpha: true}"></pos-teclado-virtual>
